import React from 'react';
import { Check } from 'lucide-react';

interface ChoiceCardProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  selected: boolean;
  onSelect: () => void;
  children?: React.ReactNode;
}

/** A selectable card in the editorial grid. Selection reads as a tinted wash,
 *  an accent rule along the top edge, and a filled corner mark. */
const ChoiceCard: React.FC<ChoiceCardProps> = ({
  icon,
  title,
  description,
  selected,
  onSelect,
  children,
}) => (
  <div
    role="radio"
    aria-checked={selected}
    tabIndex={0}
    className={`ed-card${selected ? ' is-selected' : ''}`}
    onClick={(e) => {
      const tag = (e.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      onSelect();
    }}
    onKeyDown={(e) => {
      const tag = (e.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onSelect();
      }
    }}
  >
    {selected && (
      <span className="ed-mark" aria-hidden="true">
        <Check />
      </span>
    )}
    {icon && (
      <span className="ed-card-icon" aria-hidden="true">
        {icon}
      </span>
    )}
    <h3 className="ed-card-title">{title}</h3>
    {description && <p className="ed-card-desc">{description}</p>}
    {children && <div className="ed-card-extra">{children}</div>}
  </div>
);

export default ChoiceCard;
